export default __webpack_public_path__ + "static/media/tete64.0ba5e3ba.png";